import AsyncStorage from '@react-native-async-storage/async-storage';

// Device-local UI preferences (dark mode, language, region). These are display
// prefs only — nothing here re-themes or re-translates the app yet; saving the
// choice is what "working" means for these rows until that lands separately.
const KEYS = {
  darkMode: 'settings:darkMode',
  language: 'settings:language',
  region: 'settings:region',
} as const;

export const DEFAULT_LANGUAGE = 'English';
export const DEFAULT_REGION = 'United States';

export const LANGUAGE_OPTIONS = ['English', 'Spanish', 'French'];
export const REGION_OPTIONS = ['United States', 'Cayman Islands', 'United Kingdom', 'Canada'];

export const getDarkMode = async (): Promise<boolean> => {
  const stored = await AsyncStorage.getItem(KEYS.darkMode);
  return stored === 'true';
};

export const setDarkMode = async (value: boolean): Promise<void> => {
  await AsyncStorage.setItem(KEYS.darkMode, String(value));
};

export const getLanguage = async (): Promise<string> => {
  const stored = await AsyncStorage.getItem(KEYS.language);
  return stored || DEFAULT_LANGUAGE;
};

export const setLanguage = async (value: string): Promise<void> => {
  await AsyncStorage.setItem(KEYS.language, value);
};

export const getRegion = async (): Promise<string> => {
  const stored = await AsyncStorage.getItem(KEYS.region);
  return stored || DEFAULT_REGION;
};

export const setRegion = async (value: string): Promise<void> => {
  await AsyncStorage.setItem(KEYS.region, value);
};
